export enum LinkType {
  EXTERNAL = 'EXTERNAL',
  TEL = 'TEL',
  EMAIL = 'EMAIL',
}
